module.exports = __webpack_public_path__ + "static/media/match_cost.e7eab871.svg";